import React, { useState, useEffect } from "react";

import { IconButton } from "@mui/material";
import { LocalFireDepartment as Flame, AcUnit as Snowflake, ArrowUpward, ArrowDownward } from '@mui/icons-material'

 const ThermostatControls = (props) => {
    const [temp, setTemp] = useState("--");
    const [mode, setMode] = useState("Loading");
    const [heatingSetpoint, setHeatingSetpoint] = useState("--");
    const [coolingSetpoint, setCoolingSetpoint] = useState("--");
    const [setpoint, setSetpoint] = useState()

    useEffect(() => {
        let data = props.equipment.data;
        console.log(data)
        let points = props.equipment.points;
        console.log(points)

        //We don't want to have to depend on the names of points to understand what we're getting
        //so we will depend on the point types for now instead.  Ultimately points will get loaded by brick type automatically
        //so the point type method I think is more reliable in the long term but
        //all this is subject to change as we add additional thermostats

        if (data) {
            let tempPoint = points && points.find(p => p.type === "Temperature_Sensor")
            if (tempPoint) setTemp(Math.round(data[tempPoint.uuid]))

            //These are magic numbers that we make the same for every thermostat but should
            //still probably live somewhere central
            let modePoint = points && points.find(p => p.type === "On_Off_Status")
            let statusPoint = points && points.find(p => p.type === "Operating_Mode_Status")
            
            let modePointUUID = modePoint ? modePoint.uuid : statusPoint ? statusPoint.uuid : null

            if (modePointUUID) {
                let status = Math.round(data[modePointUUID]) == 0 ? "Off" : 
                    Math.round(data[modePointUUID]) == 1 ? "Heating" :
                    Math.round(data[modePointUUID]) == 2 ? "Cooling" : 
                    Math.round(data[modePointUUID]) == 3 ? "Auto" : 
                    "Unknown"
    
                setMode(status)

                let heatPoint = points.find(p => p.type === "Heating_Temperature_Setpoint")
                let coolPoint = points.find(p => p.type === "Cooling_Temperature_Setpoint")

                if (heatPoint && coolPoint) {
                    if (status === "Auto" || status === "Off") {
                        setHeatingSetpoint(Math.round(data[heatPoint.uuid]))
                        setCoolingSetpoint(Math.round(data[coolPoint.uuid]))
                    } else if (status === "Heating") {
                        setSetpoint(Math.round(data[heatPoint.uuid]))
                    } else if (status === "Cooling") {
                        setSetpoint(Math.round(data[coolPoint.uuid]))
                    }
                } 
            }

            
        }
    },[props.equipment])

    const adjustUp = () => {
        props.controlCallback(props.equipment, 
        {
            "heating_setpoint": heatingSetpoint + 1,
            "cooling_setpoint": coolingSetpoint + 1
        })
        setHeatingSetpoint(heatingSetpoint + 1)
        setCoolingSetpoint(coolingSetpoint + 1)
    }

    const adjustDown = () => {
        props.controlCallback(props.equipment, 
            {
                "heating_setpoint": heatingSetpoint - 1,
                "cooling_setpoint": coolingSetpoint - 1
            })
            setHeatingSetpoint(heatingSetpoint - 1)
            setCoolingSetpoint(coolingSetpoint - 1)
    }

	return (
		<div className="equipment-control-container thermostat">

            <div className="status-container">
                <div className="control-header">
                    Current Temp
                </div>
                <div className="status-value-large">
                    {temp} &deg;F
                </div>
                <div className="status-tag-container">
                    <div className="status-tag">
                        {mode}
                        { mode === "Heat" ? <Flame /> :  mode === "Cool" ? <Snowflake /> : null }
                    </div>
                </div>
            </div>


            <div className="update-container">
                <div className="setpoint-container">
                    <div className="control-header">
                        Adjust To
                    </div>
                    {
                        setpoint ?
                            <div className="setpoints-container single">
                                <div className="setpoint">
                                    {setpoint} &deg;F
                                </div>
                            </div>
                            :
                            <div className="setpoints-container">
                                <div className="setpoint">
                                    <div className="setpoint-label">Cool</div>
                                    {coolingSetpoint} &deg;F
                                </div>
                                <div className="setpoint">
                                    <div className="setpoint-label">Heat</div>
                                    {heatingSetpoint} &deg;F
                                </div>
                        </div>
                        }
                </div>
                <div className="setpoint-adjustments">
                    <IconButton 
                        variant="contained" 
                        sx={{
                            bgcolor: '#003e51',
                            '&:hover': {
                                backgroundColor: '#003e51',
                            },
                            '&:active': {
                                backgroundColor: '#003e51',
                            },
                            '&:focus': {
                                backgroundColor: '#003e51',
                            },
                            boxShadow: 1,
                            borderRadius: 2,
                            marginBottom: 1
                        }}
                        aria-label={"Adjust setpoints up" }
                        size={"small"}
                        onClick={adjustUp}>
                        <ArrowUpward style={{color: "#FFF"}} />
                    </IconButton>
                    <IconButton 
                        variant="contained" 
                        sx={{
                            bgcolor: '#003e51',
                            boxShadow: 1,
                            borderRadius: 2,
                            '&:hover': {
                                backgroundColor: '#003e51',
                            },
                            '&:active': {
                                backgroundColor: '#003e51',
                            },
                            '&:focus': {
                                backgroundColor: '#003e51',
                            },
                        }}
                        aria-label={"Adjust setpoints down" }
                        size={"small"}
                        onClick={adjustDown}>
                                <ArrowDownward style={{color: "#FFF"}} />
                    </IconButton>
                </div>
            </div>
		</div>
	)
}

export default ThermostatControls;
